import { race, put, take, delay } from 'redux-saga/effects'
import { fetchAPIData } from '../../shared/services/fetchData'
import { LONG_TIMEOUT } from '../../shared/constants/wait-times'
import { MAM_LOCATIONS_ENDPOINT,MAMMO_VISIT_REGULAR } from '../../shared/constants/api-helpers.js'
import { act } from 'react'

let isSagaRunning = false
export default function* mamSearchSaga(waitTime = LONG_TIMEOUT) {
  if (isSagaRunning) return
  isSagaRunning = true

  while (true) {
    let action = yield take('GET_MAM_LOCATIONS')
    let params = action.params ? Object.assign({}, action.params) : null
    params.endPoint = MAM_LOCATIONS_ENDPOINT

    yield put({ type: 'SEARCH_LOCATIONS' })// sets a boolean for data load to true
    yield put({ type: 'CLEAR_LOCATIONS' })// clears providers and sets dataLoaded to false
    // yield put({ type: 'SET_LOCATION_SORT_ORDER', value: 'A TO Z' })// sets sort order
    yield put({ type: 'SET_LOCATIONS_CALL_FAILED', value: false })
    if (!params.VisitTypeId) { 
      params.VisitTypeId = window.sessionStorage.getItem('VisitTypeID')|| MAMMO_VISIT_REGULAR
    }

    //Payload value for dist and searchRadius cannot be less than one, otherwise call fails
    const radius = params.dist
    if (Number.isFinite(radius) && radius < 1){
      params.dist = 1
      params.searchRadius = 1
    }

    const { posts } = yield race({
      posts: fetchAPIData(params),
      timeout: delay(waitTime)
    })

    if (posts && posts.Success) {
      let cleanLocations = [];

      const invalidLocqRegex = /^(,|\s|\+)*$|^[^a-zA-Z]*$|[^a-zA-Z0-9\s,+]|^[a-zA-Z]{1,5}$|^[a-zA-Z]{6,}$/; 
      // ^(,|\s|\+)*$ matches strings that consist of only commas, whitespace, or plus signs
      // ^[^a-zA-Z]*$ matches strings that contain no alphabetic characters at all
      // [^a-zA-Z0-9\s,+] matches any string that contains characters other than letters, digits, whitespace, commas, or plus signs
      // ^[a-zA-Z]{1,5}$ matches strings that consist of 1 to 5 alphabetic characters only
      // ^[a-zA-Z]{6,}$ matches strings that consist of 6 or more alphabetic characters only

      if (params.locq && invalidLocqRegex.test(params.locq)) {
        cleanLocations = [];
      } else if (params.locq) {

        // Normalize the search query
        const normalizedQuery = params.locq.trim().toLowerCase();

        // Filter locations based on the normalized search query
        const queryMatchedLocations = posts.MammoLocations.filter(loc => {
          const normalizedName = loc.City.trim().toLowerCase();
          return normalizedName.includes(normalizedQuery) || normalizedQuery.includes(normalizedName);
        });

        // If no matches are found, return an empty array
        // unless there's postmammolocations from map movement
        if (queryMatchedLocations.length === 0) {
          cleanLocations = posts.MammoLocations ? posts.MammoLocations.filter(loc => loc.Distance <= radius) : []

        } else {
          cleanLocations = [...new Set([...queryMatchedLocations, ...posts.MammoLocations])];
        }
      } else if (posts.MammoLocations && Number.isFinite(radius) && radius < 1) {
        cleanLocations = posts.MammoLocations.filter(loc => loc.Distance <= radius);
      } else {
        cleanLocations = posts.MammoLocations;
      }
      let sortedLocations = sortLocations(cleanLocations)
      sortedLocations = sortedLocations.map((loc) => ({ ...loc, Address: loc.Address.replaceAll('.', '') }))

      window.sessionStorage.setItem('visitDuration', posts.Duration) 
      window.sessionStorage.setItem('locationCount', posts.MammoLocations.length)     
      window.dispatchEvent(new Event("sessionUpdated"))  
      yield put({ type: 'SET_LOCATIONS', value: sortedLocations })
      yield put({ type: 'SET_MAM_RADIUS', value: radius })
      if (params.lat && params.lng && params.dist && params.sortBy === 'Distance') {
        yield put({ type: 'SET_LOCATION_SORT_ORDER', value: 'Distance' })
      }
      else {
        yield put({ type: 'SET_LOCATION_SORT_ORDER', value: 'A TO Z' })
      }
    } else {
      yield put({ type: 'SET_LOCATIONS_CALL_FAILED', value: true })

      //When call fails, default to empty locations list
      window.sessionStorage.setItem('visitDuration', 15)
      window.sessionStorage.setItem('locationCount', 0)
      window.dispatchEvent(new Event("sessionUpdated"))

      yield put({ type: 'SET_LOCATIONS', value: [] });
      if (params.lat && params.lng && params.dist && params.sortBy === 'Distance') {
        yield put({ type: 'SET_LOCATION_SORT_ORDER', value: 'Distance' })
      }
      else {
        yield put({ type: 'SET_LOCATION_SORT_ORDER', value: 'A TO Z' })
      }
    }
  }
}

const sortLocations = (locations) => (
  locations.sort((a, b) => {
    return a.Name.toUpperCase() > b.Name.toUpperCase() ? 1 : -1
  })
)

